module.exports = __webpack_public_path__ + "assets/img/3db6-ke.svg";